import { render, staticRenderFns } from "./RecursiveCollapse.vue?vue&type=template&id=26971027&"
import script from "./RecursiveCollapse.vue?vue&type=script&lang=ts&"
export * from "./RecursiveCollapse.vue?vue&type=script&lang=ts&"
import style0 from "./RecursiveCollapse.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports